<template>
  <div class="component">
    <el-upload
      v-loading="loading"
      :limit="1"
      ref="upload"
      :file-list="fileList"
      :action="config.upload"
      accept="image/png,image/jpg,image/jpeg"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <div v-if="value" class="avatar">
        <img :src="value" />
      </div>
      <div v-else>
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <p class="add-text">添加封面</p>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: "",
      require: true
    }
  },
  data() {
    return {
      loading: false,
      fileList: []
    };
  },
  methods: {
    uploadSuccess(res) {
      this.loading = false;
      if (res.code === 200) {
        this.$emit("input", res.data);
      } else {
        this.$message.error(res.mes);
      }
      this.fileList = [];
    },
    beforeAvatarUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        console.log(1);
        this.$message.error("上传头像图片大小不能超过 10MB!");
      } else {
        this.loading = true;
      }
      return isLt10M;
    }
  }
};
</script>

<style lang="less" scoped>
.component {
  /deep/ .el-upload {
    width: 66px;
    height: 66px;
    background: #ffffff;
    border-radius: 4px;
    > div {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .avatar {
      width: 100%;
      height: 100%;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
      }
      &:hover:after {
        content: "更换图片";
        display: inline-block;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 3px;
      }
    }
    .avatar-uploader-icon {
      font-size: 14px;
      font-weight: bold;
      color: #2154f4;
      margin-bottom: 4px;
    }
    .add-text {
      font-size: 10px;
      font-weight: 400;
      color: #2154f4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/MobileAppoint/components/UploadImg.vue